import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { reduce, forEach } from 'lodash';


const HeaderCartBtnWrapperBlock = styled.div`
  float: left;
  display: inline-block;
  position: relative;
  margin-left: 15px;
  vertical-align: middle
`;

const HeaderCartBtnBlock = styled.button`
  width: 30px;
  height: 30px;
  backgroundSize: "cover";
  background-image: url(${props => props.img || ''});
  background-position: center;
  background-repeat: no-repeat;
  margin-top: 5px;
`;

const HeaderCartBtnCountBlock = styled.span`
  display: ${props => props.display};
  position: absolute;
  top: 0px;
  right: -12px;
  padding: 0 6px;
  background-color: #79b88a;
  border-radius: 10px;
  font-size: 12px
`;

const HeaderCartBtn = () => {

  const [cartCnt, setCartCnt] = useState(0);
  const history = useHistory();

  const { accessToken, cartProdList, updateStatus } = useSelector(
    ({ userReducer, userCartReducer }) => ({
      accessToken: userReducer.accessToken,
      cartProdList: userCartReducer.cartProdList,
      updateStatus: userCartReducer.updateStatus
    })
  );

  useEffect(() => {

    let cnt = 0;
    forEach(cartProdList, (curobj, index) => {
      cnt += (curobj.qty * 1);
    })


    setCartCnt(cnt);

  }, [accessToken, cartProdList, updateStatus])

  const handlerCartClick = () => {
    history.push("/mycart");
  }

  return (
    <HeaderCartBtnWrapperBlock>
      <HeaderCartBtnBlock
        onClick={handlerCartClick}
        img="/assets/images/icon/es_cart-icon.png"
      />
      <HeaderCartBtnCountBlock display={cartCnt > 0 ? 'block' : 'none'}>{cartCnt}</HeaderCartBtnCountBlock>
    </HeaderCartBtnWrapperBlock>
  );
};

export default HeaderCartBtn;